import { render, staticRenderFns } from "./chart-of-account.vue?vue&type=template&id=6bebe57a"
import script from "./chart-of-account.vue?vue&type=script&lang=js"
export * from "./chart-of-account.vue?vue&type=script&lang=js"
import style0 from "./chart-of-account.vue?vue&type=style&index=0&id=6bebe57a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports